/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'pki-profile';

export const pkiProfileModalBreadcrumbTitle = `${prefix}.pkiProfileModalBreadcrumbTitle`;
export const addCaModalBreadcrumbTitle = `${prefix}.addCaModalBreadcrumbTitle`;
export const addCrlModalBreadcrumbTitle = `${prefix}.addCrlModalBreadcrumbTitle`;

export const ENGLISH = {
    [pkiProfileModalBreadcrumbTitle]: 'PKI Profile',
    [addCaModalBreadcrumbTitle]: 'Add CA',
    [addCrlModalBreadcrumbTitle]: 'Add CRL',
};
